export default "__VITE_ASSET__Cc92aVox__"